import { render, staticRenderFns } from "./wave3d.vue?vue&type=template&id=d554063a&scoped=true"
import script from "./wave3d.vue?vue&type=script&lang=js"
export * from "./wave3d.vue?vue&type=script&lang=js"
import style0 from "./wave3d.vue?vue&type=style&index=0&id=d554063a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d554063a",
  null
  
)

export default component.exports